import React,{useRef,useEffect} from 'react';  
 
  import GifGrid from '../components/GifGrid'
  import CheckItOut from '../components/CheckItOut'
  import {Divider 
  } from 'semantic-ui-react'
 
  function AbilityPage(props){ 

      const header = <div><i>Cascade Tactics</i> brings the genre to a new level with interesting and strategic abilities</div>
      return   <div> <GifGrid
        width={props.width}
        height={props.height}
        headerText ={header}
        gifData={[
          {headerText:"Place a bomb that detonates when hit", gif:"FireBomb1.gif"},
          {headerText:"Divide the terrain in two with Earthquake", gif:"Earthquake2.gif"},
          {headerText:"Protect allies from spells with Reflect", gif:"Reflect1.gif"},
          {headerText:"Teleport enemies or allies", gif:"Teleport1.gif"},
          {headerText:"Change how characters move with Freeze Floor", gif:"FreezeFloor2.gif"},
          {headerText:"Open up two Warpgates and move between the two", gif:"Warpgate1.gif"},

        ]}
      > 
      </GifGrid> 
      <Divider></Divider>
      <CheckItOut hiddenButton ="abilities"></CheckItOut>
      </div>
  }
  
export default AbilityPage;